import { Stack } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CardV2 as Card, Heading, Text } from '@feathr/components';

import MetaConnectButton from '../MetaConnectButton';
import { useMetaSetupSteps } from './MetaGetStarted.hooks';
import MetaSetupSteps from './MetaSetupSteps';

import * as styles from './MetaGetStarted.css';

function MetaGetStarted(): JSX.Element {
  const { t } = useTranslation();
  const setupSteps = useMetaSetupSteps();

  return (
    <Card name={'get-started-card'} width={'full'}>
      <Stack className={styles.root} gap={'xl'}>
        <Stack gap={4}>
          <Heading order={3} variant={'h3'}>
            {t('Get Started')}
          </Heading>
          <Text.DefaultRegular>
            {t('Connect your Meta accounts to unlock paid social advertising capabilities.')}
          </Text.DefaultRegular>
        </Stack>

        <Stack align={'center'} gap={'md'}>
          <MetaSetupSteps steps={setupSteps} />

          <MetaConnectButton />

          <Text.SmallRegular className={styles.termsText}>
            {t("By connecting, you agree to Meta's ")}
            <Text.SmallRegular
              className={styles.termsLink}
              href={'https://www.facebook.com/terms.php'}
              inline={true}
              target={'_blank'}
            >
              {t('Terms of Service')}
            </Text.SmallRegular>
            {t(' and ')}
            <Text.SmallRegular
              className={styles.termsLink}
              href={'https://www.facebook.com/policy.php'}
              inline={true}
              target={'_blank'}
            >
              {t('Privacy Policy')}
            </Text.SmallRegular>
          </Text.SmallRegular>
        </Stack>
      </Stack>
    </Card>
  );
}

export default MetaGetStarted;
